export const COURSE_PROGRESS_KEY = "theqahub-course-progress-v1";

export const COURSE_CATALOG = [
  {
    id: "cypress",
    title: "Cypress desde 0",
    level: "Junior",
    videos: [
      {
        id: "cypress-introduccion",
        title: "Introducción a Cypress",
        embed: "https://www.youtube.com/embed/Y-lvGx4Nebo",
        watchUrl: "https://www.youtube.com/watch?v=Y-lvGx4Nebo",
      },
      {
        id: "cypress-querying",
        title: "Hacer Querying en Cypress",
        embed: "https://www.youtube.com/embed/jzgn377TgWA?si=eNGgNktanNPD8jY6",
        watchUrl: "https://www.youtube.com/watch?v=jzgn377TgWA",
      },
      {
        id: "cypress-traversal",
        title: "Comandos de Traversal paso a paso",
        embed: "https://www.youtube.com/embed/H7meUk6yRJY?si=R6dm--Wzw4rF_aLC",
        watchUrl: "https://www.youtube.com/watch?v=H7meUk6yRJY",
      },
      {
        id: "cypress-actions",
        title: "Aprende las actions",
        embed: "https://www.youtube.com/embed/IhupF-KKGsg?si=12LNt14BcnxOTk6l",
        watchUrl: "https://www.youtube.com/watch?v=IhupF-KKGsg",
      },
      {
        id: "cypress-browser",
        title: "Control total del navegador",
        embed: "https://www.youtube.com/embed/jMjQ3Oxk6rE?si=SjVCbvGR7g1jGznq",
        watchUrl: "https://www.youtube.com/watch?v=jMjQ3Oxk6rE",
      },
      {
        id: "cypress-assertions",
        title: "Aserciones explicadas desde 0",
        embed: "https://www.youtube.com/embed/6XZxOH4WYCw?si=xOtAH6ghFNo6JNsr",
        watchUrl: "https://www.youtube.com/watch?v=6XZxOH4WYCw",
      },
      {
        id: "cypress-commands",
        title: "Ejecutar comandos y otras acciones",
        embed: "https://www.youtube.com/embed/rDZ54zFsqdk?si=PF30bZSrcILIZbRE",
        watchUrl: "https://www.youtube.com/watch?v=rDZ54zFsqdk",
      },
    ],
  },
  {
    id: "postman",
    title: "Postman + Newman",
    level: "Junior",
    videos: [
      {
        id: "postman-introduccion",
        title: "Introducción a Postman",
        embed: "https://www.youtube.com/embed/LLJt1alI0vg?si=U6ZPAfXgItPuZz0B",
        watchUrl: "https://www.youtube.com/watch?v=LLJt1alI0vg",
      },
      {
        id: "postman-variables",
        title: "Variables y entornos",
        embed: "https://www.youtube.com/embed/oQSoibG-1II?si=xLoqg7_ZWVXm1BsQ",
        watchUrl: "https://www.youtube.com/watch?v=oQSoibG-1II",
      },
    ],
  },
  {
    id: "cucumber",
    title: "Cucumber con WebdriverIO",
    level: "Junior",
    videos: [
      {
        id: "cucumber-introduccion",
        title: "Introducción a Cucumber",
        embed: "https://www.youtube.com/embed/dipBw1WAg24?si=73l5NjlICdrOao_9",
        watchUrl: "https://www.youtube.com/watch?v=dipBw1WAg24",
      },
      {
        id: "cucumber-gherkin",
        title: "Automatización API y Gherkin tables",
        embed: "https://www.youtube.com/embed/tvQTni3PXAc?si=MkHrsM-YUz0elCg9",
        watchUrl: "https://www.youtube.com/watch?v=tvQTni3PXAc",
      },
      {
        id: "cucumber-hooks",
        title: "Domina los hooks",
        embed: "https://www.youtube.com/embed/P2Ikz5hJkZs?si=-vQrGyua8eoQa82p",
        watchUrl: "https://www.youtube.com/watch?v=P2Ikz5hJkZs",
      },
    ],
  },
];
